export type CallState = {
  incomingCallPrefix: 'incoming-call-';
}

export const INCOMING_CALL_PREFIX = 'incoming-call-';
export const INCOMING_CALL_PREFIX_BETA = 'system:incoming-call-';